import {useCallback} from 'react';
import useRequestRelayQuoteMutation from 'src/api/graphql/useRequestRelayQuoteMutation';
import {getStore} from 'src/v2/state/store';
import type {
  OpenapiPostV1CryptoInternalRelayQuoteInputInputChainEnum,
  OpenapiPostV1CryptoInternalRelayQuoteInputInputCurrencyEnum,
} from '@stripe-internal/data-v1/schema/types';

export const useRequestRelayQuote = () => {
  const store = getStore();
  const [requestRelayQuote] = useRequestRelayQuoteMutation();
  const sessionId = store.useSelector((state) => state.id);
  const clientSecret = store.useSelector((state) => state.clientSecret);

  return useCallback(
    async (
      inputCurrency: OpenapiPostV1CryptoInternalRelayQuoteInputInputCurrencyEnum,
      inputChain: OpenapiPostV1CryptoInternalRelayQuoteInputInputChainEnum,
    ) => {
      const response = await requestRelayQuote({
        variables: {
          input: {
            client_secret: clientSecret,
            crypto_payin_session: sessionId,
            input_chain: inputChain,
            input_currency: inputCurrency,
          },
        },
      });

      const quote = response.data?.v1CryptoInternalRelayQuote;

      if (response.error) {
        throw response.error;
      }

      if (!quote) {
        throw new Error('No quote returned from requestRelayQuote');
      }

      store.setValue((state) => {
        state.anyCryptoDeposit.quote = {
          depositAddress: quote.depositAddress,
          inputAmount: quote.inputAmount,
          inputChain: quote.inputChain,
          inputCurrency: quote.inputCurrency,
        };
      });

      return quote;
    },
    [sessionId, clientSecret, requestRelayQuote, store],
  );
};
